import React from 'react';
import { LargeHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';
import LargeButton from '@/components/Views/Buttons';
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

export const CreatorsRock = ({ heading = null, content = null, id }) => {
    return (
        <section id={id} className='creators-rock default-px default-py'>
            <div className='creators-rock--wrapper'>
                <div className='creators-rock--content mx-auto default-max-w'>
                    <div className='creators-rock--content-child'>
                        <LargeHeading heading='Our Creators ROCK' className='mt-0' />
                        <div className='creators-rock--photos hide-desktop'>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar1.png' alt='artist 1' />
                            </div>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar2.png' alt='artist 2' />
                            </div>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar3.png' alt='artist 3' />
                            </div>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar4.png' alt='artist 4' />
                            </div>
                        </div>
                        <NormalText>
                            Muzology has assembled a rockstar team of GRAMMY and Emmy award-winning hit songwriters, music producers, choreographers and video
                            producers who have worked with artists including{' '}
                            <span className='font-bold'>Ariana Grande, Justin Bieber, Jennifer Lopez, Usher, PINK, Britney Spears, NSYNC, and Beyoncé.</span>{' '}
                            Our technologists have worked on some of the most successful video games (including Deer Hunter 2 and Halo) and developed Apple
                            featured apps.
                        </NormalText>
                        <div className='creators-rock--photos hide-mobile'>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar1.png' alt='artist 1' />
                            </div>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar2.png' alt='artist 2' />
                            </div>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar3.png' alt='artist 3' />
                            </div>
                            <div className='creators-rock--photo-wrapper'>
                                <img className='creators-rock--photo' src='/assets/graphics/cr-avatar4.png' alt='artist 4' />
                            </div>
                        </div>

                        <div className='flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 w-full'>
                            <LargeButton
                                className='purple-button h-[44px] w-[210px]'
                                text='Sign Up My Child'
                                href={MUZOLOGY_SIGNUP_URL}
                                rightArrow={true}
                                id={id + '-sign-up-my-child'}
                            />
                            <LargeButton
                                href='/signup'
                                className='blue-button h-[44px] w-[210px]'
                                text='Sign Up As Educator'
                                rightArrow={true}
                                id={id + '-sign-up-as-educator'}
                            />
                        </div>
                    </div>
                    <div className='block creators-rock--content-child'>
                        <img className='creators-rock--featured' src='/assets/graphics/cr-featured.png' alt='Featured Creators' />
                    </div>
                </div>
            </div>
            <style jsx>{`
                .creators-rock {
                    width: 100%;
                    background: #fff;

                    .creators-rock--wrapper {
                        .creators-rock--content {
                            display: flex;
                            align-items: center;

                            .creators-rock--content-child {
                                &:first-child {
                                    padding-right: 85px;
                                    flex: 1;
                                }

                                &:last-child {
                                    padding-left: 10px;
                                    max-width: 50%;
                                }

                                .creators-rock--title {
                                    font-weight: 800;
                                    font-size: 42px;
                                    line-height: 48px;
                                    color: #121651;
                                    margin: 0;
                                }

                                .creators-rock--description {
                                    font-weight: 500;
                                    font-size: 18px;
                                    line-height: 25px;
                                    color: #4f4f4f;
                                    margin: 25px 0 0;
                                }

                                .creators-rock--photos {
                                    display: flex;
                                    align-items: center;
                                    margin: 40px 0 0 0;

                                    &.hide-desktop {
                                        display: none;
                                        @media (max-width: 767px) {
                                            display: flex;
                                        }
                                    }

                                    &.hide-mobile {
                                        display: flex;
                                        @media (max-width: 767px) {
                                            display: none;
                                        }
                                    }

                                    .creators-rock--photo-wrapper {
                                        flex: 1;
                                        max-width: 90px;
                                        max-height: 110px;
                                        margin: 0 8px;

                                        img {
                                            width: 100%;
                                            height: auto;
                                        }

                                        &:first-child {
                                            margin-left: 0;
                                        }

                                        &:last-child {
                                            margin-right: 0;
                                        }
                                    }
                                }

                                .creators-rock--featured {
                                    max-width: 100%;
                                    height: auto;
                                }
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        //padding: 48px 40px;
                    }

                    @media (max-width: 768px) {
                        //padding: 48px 40px 20px;
                        .creators-rock--wrapper {
                            .creators-rock--content {
                                flex-direction: column;

                                .creators-rock--content-child {
                                    &:first-child {
                                        padding: 0 0 15px;
                                    }

                                    &:last-child {
                                        padding: 15px 0 0;
                                        max-width: 100%;
                                    }

                                    .creators-rock--title {
                                        font-size: 36px;
                                        text-align: center;
                                    }

                                    .creators-rock--description {
                                        font-size: 16px;
                                    }

                                    .creators-rock--photos {
                                        justify-content: center;
                                    }
                                }
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        //padding: 48px 20px;
                    }
                }
            `}</style>
        </section>
    );
};
